import { createSlice } from '@reduxjs/toolkit'

import { IOtr } from 'types/otr.types'
import { setMessageData } from './conversations.slice'

const initialOtrState: IOtr = {}

export const { actions: otrActions, reducer: otrReducer } = createSlice({
  name: 'otr',
  initialState: initialOtrState,
  reducers: {
    createOtrRoom: (state, { payload: { roomId, requestSentAt, createdByUserId, users, userData } }) => {
      if (!state[roomId]) {
        state[roomId] = {
          requestSentAt,
          roomId,
          messages: [],
          createdByUserId: createdByUserId || '',
          users: users || [],
          userData: userData || {},
        }
      }
    },
    deleteOtrRoom: (state, { payload: { roomId } }) => {
      if (state[roomId]) {
        delete state[roomId]
      }
    },
    sendOtrMessage: (state, { payload }) => {
      const roomId = payload?.roomId
      if (!roomId) return

      // room yoksa stub oluştur (race condition çözümü)
      if (!state[roomId]) {
        state[roomId] = {
          requestSentAt: Date.now().toString(),
          roomId,
          messages: [],
          createdByUserId: payload?.createdByUserId || '',
          users: payload?.users?.map?.((u: any) => u?._id).filter(Boolean) || payload?.members || [],
          userData: payload?.userData || {},
        }
      }

      const room = state[roomId]
      if (!room.messages) room.messages = []

      room.messages.unshift(setMessageData(payload))
    },
    updateOtrMessage: (state, { payload }) => {
      const { roomId, cti, message } = payload
      // userData yoksa users array'inden üret
      const patchedMessage = { ...message }
      if (!patchedMessage.userData && Array.isArray(patchedMessage.users)) {
        patchedMessage.userData = {}
        patchedMessage.users.forEach((user: any) => {
          if (user._id) patchedMessage.userData[user._id] = user
        })
      }
      if (state[roomId] && state[roomId].messages) {
        const messageIndex = state[roomId].messages.findIndex(msg => msg.cti === cti)
        if (messageIndex !== -1) {
          state[roomId].messages[messageIndex] = {
            ...state[roomId].messages[messageIndex],
            ...patchedMessage
          }
        } else {
          state[roomId].messages.unshift(patchedMessage)
        }
      }
    },
    removeOtrMessage: (state, { payload }) => {
      const { roomId, cti } = payload
      const msgs = state[roomId]?.messages
      if (!msgs) return
      const idx = msgs.findIndex((m: any) => m?.cti === cti)
      if (idx !== -1) {
        msgs.splice(idx, 1)
      }
    },
  },
})
